<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer class="the-footer justify-between clear-both">
        <p>
          <span>Copyright &copy;2020</span><span>&nbsp;</span>
          <a href="https://kalkulator.vitme.pl" target="_blank" rel="nofollow">Vitme.pl</a>
          <span class="hidden sm:inline-block">, Wszystkie prawa zastrzeżone</span>
        </p>
    </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
